import { traverseFieldWidgetsOfContainer } from "@/utils/util";
export default {
  inject: ['getGlobalDsv'],
  computed: {
    customClass: function customClass() {
      return this.widget.options.customClass || '';
    },
    formModel: {
      cache: false,
      get: function get() {
        return this.globalModel.formModel;
      }
    }
  },
  mounted: function mounted() {
    this.callSetHidden();
  },
  methods: {
    unregisterFromRefList: function unregisterFromRefList() {
      //销毁容器组件时注销组件ref
      if (this.refList !== null && !!this.widget.options.name) {
        var oldRefName = this.widget.options.name;
        delete this.refList[oldRefName];
      }
    },
    /* 主动触发setHidden()方法，以清空被隐藏容器内字段组件的校验规则！！ */callSetHidden: function callSetHidden() {
      if (this.widget.options.hidden === true) {
        this.setHidden(true);
      }
    },
    //--------------------- 以下为组件支持外部调用的API方法 begin ------------------//
    /* 提示：用户可自行扩充这些方法！！！ */
    setHidden: function setHidden(flag) {
      var _this = this;
      this.widget.options.hidden = flag;

      /* 容器被隐藏后，需要同步清除容器内部字段组件的校验规则 */
      var clearRulesFn = function clearRulesFn(fieldWidget) {
        var fwName = fieldWidget.options.name;
        var fwRef = _this.getWidgetRef(fwName);
        if (flag && !!fwRef && !!fwRef.clearFieldRules) {
          fwRef.clearFieldRules();
        }
        if (!flag && !!fwRef && !!fwRef.buildFieldRules) {
          fwRef.buildFieldRules();
        }
      };
      traverseFieldWidgetsOfContainer(this.widget, clearRulesFn);
    },
    activeTab: function activeTab(tabIndex) {
      var _this2 = this;
      //tabIndex从0计数
      if (tabIndex >= 0 && tabIndex < this.widget.tabs.length) {
        this.widget.tabs.forEach(function (tp, idx) {
          tp.options.active = idx === tabIndex;
          if (idx === tabIndex) {
            _this2.activeTabName = tp.options.name;
          }
        });
      }
    },
    disableTab: function disableTab(tabIndex) {
      if (tabIndex >= 0 && tabIndex < this.widget.tabs.length) {
        this.widget.tabs[tabIndex].options.disabled = true;
      }
    },
    enableTab: function enableTab(tabIndex) {
      if (tabIndex >= 0 && tabIndex < this.widget.tabs.length) {
        this.widget.tabs[tabIndex].options.disabled = false;
      }
    },
    hideTab: function hideTab(tabIndex) {
      if (tabIndex >= 0 && tabIndex < this.widget.tabs.length) {
        this.widget.tabs[tabIndex].options.hidden = true;
      }
    },
    showTab: function showTab(tabIndex) {
      if (tabIndex >= 0 && tabIndex < this.widget.tabs.length) {
        this.widget.tabs[tabIndex].options.hidden = false;
      }
    },
    setWidgetOption: function setWidgetOption(optionName, optionValue) {
      //通用组件选项修改API
      if (this.widget.options.hasOwnProperty(optionName)) {
        this.widget.options[optionName] = optionValue;
      }
    },
    /**
     * 获取子表单的行数
     */
    getSubFormRowCount: function getSubFormRowCount() {
      return !this.rowIdData ? 0 : this.rowIdData.length;
    },
    disableSubFormRow: function disableSubFormRow(rowIndex) {
      var _this3 = this;
      this.widget.widgetList.forEach(function (subWidget) {
        var swRefName = subWidget.options.name + '@row' + _this3.rowIdData[rowIndex];
        var foundSW = _this3.getWidgetRef(swRefName);
        if (!!foundSW) {
          foundSW.setDisabled(true);
        }
      });
    },
    enableSubFormRow: function enableSubFormRow(rowIndex) {
      var _this4 = this;
      this.widget.widgetList.forEach(function (subWidget) {
        var swRefName = subWidget.options.name + '@row' + _this4.rowIdData[rowIndex];
        var foundSW = _this4.getWidgetRef(swRefName);
        if (!!foundSW) {
          foundSW.setDisabled(false);
        }
      });
    },
    disableSubForm: function disableSubForm() {
      var _this5 = this;
      if (this.rowIdData.length > 0) {
        this.rowIdData.forEach(function (dataRow, rIdx) {
          _this5.disableSubFormRow(rIdx);
        });
      }

      //禁用3个操作按钮
      this.actionDisabled = true;
    },
    enableSubForm: function enableSubForm() {
      var _this6 = this;
      if (this.rowIdData.length > 0) {
        this.rowIdData.forEach(function (dataRow, rIdx) {
          _this6.enableSubFormRow(rIdx);
        });
      }

      //启用3个操作按钮
      this.actionDisabled = false;
    },
    resetSubForm: function resetSubForm() {
      //重置subForm数据为空
      if (this.widget.type === 'sub-form') {
        var subFormModel = this.formModel[this.widget.options.name];
        if (!!subFormModel) {
          subFormModel.splice(0, subFormModel.length);
          this.rowIdData.splice(0, this.rowIdData.length);
        }
        if (this.widget.options.showBlankRow) {
          this.addSubFormRow();
        }
      }
    },
    getSubFormValues: function getSubFormValues() {
      var needValidation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.widget.type === 'sub-form') {
        //TODO: 逐行校验子表单！暂未实现！！
        return this.formModel[this.widget.options.name];
      } else {
        this.$message.error(this.i18nt('render.hint.nonSubFormType'));
      }
    },
    setSubFormValues: function setSubFormValues(subFormValues) {
      //TODO: 待实现！！
    },
    // validateField(fieldName) { //逐行校验子表单字段
    //   //TODO:
    // },
    //
    // validateSubForm() { //逐行校验子表单全部字段
    //   //TODO:
    // },
    /**
     * 动态增加自定义css样式
     * @param className
     */
    addCssClass: function addCssClass(className) {
      if (!this.widget.options.customClass) {
        this.widget.options.customClass = [className];
      } else {
        this.widget.options.customClass.push(className);
      }
    },
    /**
     * 动态移除自定义css样式
     * @param className
     */
    removeCssClass: function removeCssClass(className) {
      if (!this.widget.options.customClass) {
        return;
      }
      var foundIdx = -1;
      this.widget.options.customClass.map(function (cc, idx) {
        if (cc === className) {
          foundIdx = idx;
        }
      });
      if (foundIdx > -1) {
        this.widget.options.customClass.splice(foundIdx, 1);
      }
    } //--------------------- 以上为组件支持外部调用的API方法 end ------------------//
  }
};